export default __webpack_public_path__ + "static/loyall-featured-image-approach-light-6ab57edf3fcd5048c5ddc1dd66e95769.jpg";